var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 4.5,
    fill: "#0AA06A",
    stroke: "#0AA06A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1909 5.86268L8.00293 10.297L5.815 7.98035L5.66959 7.82639L5.52419 7.98035L4.85753 8.68623L4.72783 8.82355L4.85753 8.96088L7.85753 12.1373L8.00294 12.2913L8.14834 12.1373L13.1483 6.84321L13.278 6.70588L13.1483 6.56856L12.4817 5.86268L12.3363 5.70872L12.1909 5.86268Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckedIcon);
export default __webpack_public_path__ + "static/media/checkbox-checked-icon.082def57bed4e173ab5e18624fda9d2c.svg";
export { ForwardRef as ReactComponent };